import type { User } from "../types";

export const defaultUser: User = {
  id: "user-1",
  fullName: "Гость",
  role: "visitor",
};
